import { IFormAction } from '../../@types/entityTypes';
import { ProductFormAction } from './ProductFormAction';
import { useContext } from 'react';
import ConnectedFormContext from '../../components/Context/ConnectedFormContext';
import { useHistory } from 'react-router';
import { IProduct, ProductClass } from '../../graphql/schema/p4types';
import { Assembly } from '../../graphql/entities';

export const useRaiseAssemblyOrderAction: () => [IFormAction<ProductFormAction>] = () => {
  const connectedForm = useContext(ConnectedFormContext);
  const history = useHistory();
  const product: IProduct = connectedForm.values as IProduct;

  return [
    {
      key: 'raiseAssemblyOrder',
      actionReference: ProductFormAction.RaiseAssemblyOrder,
      text: 'Raise Assembly Order',
      onClick: () => {
        history.push({
          pathname: `${Assembly.formUrl}New/${product.id}`,
          state: {
            previousLocation: history.location?.pathname || 'back',
          },
        });
      },
      condition: (product: IProduct) => product.productClass === ProductClass.Assembly,
    },
  ];
};
